const IGNORED_ERRORS = /InvalidAccessError|SecurityError/;

// Use to decorate a function to prevent errors.
export const tryFunctionHelperModule = angular
  .module('Q.helpers.try-function', [])

  .factory('tryFunction', function ($log) {
    return function tryFunction(fn) {
      return function (...args) {
        try {
          return fn(...args);
        } catch (ex) {
          if (IGNORED_ERRORS.test(ex)) {
            // Log security errors as warnings instead of debug so they're visible in production
            $log.warn('[SmartIDE] Security error (expected):', ex);
          } else {
            // $log.error automatically sends to Sentry
            $log.error(ex);
          }
        }
      };
    };
  });
